import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"16px"} }, "Currently selected", -1)
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { style: {"font-size":"14px"} }

import { IonContent, IonList, IonItem, IonModal } from '@ionic/vue';
import ArticleQuantityCardBase from '@components/article/ArticleQuantityCardBase.vue';
import { computed, toRefs, withDefaults } from 'vue';
import useMovePlacementsActionStore from '@/store/movePlacementsAction';
import { storeToRefs } from 'pinia';

interface Props {
  isOpen: boolean;
  divideByPlace?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MovePlacementsSelectedModal',
  props: {
    isOpen: { type: Boolean },
    divideByPlace: { type: Boolean, default: true }
  },
  emits: ['update:isOpen'],
  setup(__props: any, { emit }) {

const props = __props as { isOpen: boolean, divideByPlace: boolean };

const movePlacementsActionStore = useMovePlacementsActionStore();
const { selectedArticles } = storeToRefs(movePlacementsActionStore);




const { isOpen, divideByPlace } = toRefs(props);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    mode: "ios",
    "is-open": _unref(isOpen),
    "initial-breakpoint": 0.4,
    breakpoints: [0, 0.4, 0.7, 0.9],
    onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (emit('update:isOpen', false))),
    onDidPresent: _cache[2] || (_cache[2] = ($event: any) => (emit('update:isOpen', true)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(IonList), {
            style: {"max-height":"100%","overflow":"auto","padding-bottom":"64px"},
            onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, {
            default: _withCtx(() => [
              (_unref(divideByPlace) === false)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(movePlacementsActionStore).getRemainingSelectedCombinedPlace(), (article) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), {
                      key: article.code,
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ArticleQuantityCardBase, { article: article }, {
                          right: _withCtx(() => [
                            _createTextVNode(_toDisplayString(article.quantity) + " szt. ", 1)
                          ]),
                          _: 2
                        }, 1032, ["article"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(selectedArticles), (articles, placeCode) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), {
                      key: placeCode,
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("h3", _hoisted_3, _toDisplayString(placeCode), 1),
                          _createVNode(_unref(IonList), null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles, (article) => {
                                return (_openBlock(), _createBlock(ArticleQuantityCardBase, {
                                  key: article.document_product_id,
                                  article: article
                                }, {
                                  right: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(article.quantity) + " szt. ", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["article"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "initial-breakpoint", "breakpoints"]))
}
}

})